import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Phone, Mail, Check } from "lucide-react";
import { api } from "../lib/api";
import { PageHero } from "../components/ui-parts";

export default function Contact() {
  const [s, setS] = useState(null);
  const [form, setForm] = useState({ name: "", mobile: "", email: "", subject: "", message: "" });
  const [done, setDone] = useState(false);
  useEffect(() => { api.get("/settings").then(r => setS(r.data)); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setDone(true); toast.success("Message sent"); setForm({ name: "", mobile: "", email: "", subject: "", message: "" }); }
    catch { toast.error("Failed to send"); }
  };
  return (
    <div data-testid="contact-page">
      <PageHero badge="Contact" title="Get in touch" subtitle="Questions, collaboration, volunteering — we would love to hear from you." />
      <section className="section">
        <div className="container-narrow grid gap-8 md:grid-cols-2">
          <div>
            <div className="js-card p-6">
              <div className="flex items-start gap-3"><MapPin className="text-[var(--js-primary)] mt-1" /><div><div className="font-semibold">Office</div><div className="text-sm text-[var(--js-muted)]">{s?.contact?.address}</div></div></div>
              <div className="flex items-start gap-3 mt-4"><Phone className="text-[var(--js-primary)] mt-1" /><div><div className="font-semibold">Phone</div><div className="text-sm text-[var(--js-muted)]">{s?.contact?.phone}</div></div></div>
              <div className="flex items-start gap-3 mt-4"><Mail className="text-[var(--js-primary)] mt-1" /><div><div className="font-semibold">Email</div><div className="text-sm text-[var(--js-muted)]">{s?.contact?.email}</div></div></div>
            </div>
            {s?.contact?.map_embed && <div className="js-card mt-6 overflow-hidden"><iframe src={s.contact.map_embed} title="map" className="w-full h-64" /></div>}
          </div>
          <div className="js-card p-6" data-testid="contact-form">
            {done ? <div className="text-center py-6"><Check size={32} className="mx-auto text-[var(--js-accent)]" /><p className="mt-2 font-semibold">Message sent</p></div> :
              <form onSubmit={submit} className="space-y-3">
                {[["name", "Name *"], ["mobile", "Mobile"], ["email", "Email *"], ["subject", "Subject *"]].map(([k, l]) => (
                  <input key={k} required={l.includes("*")} type={k === "email" ? "email" : "text"} placeholder={l} value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} className="w-full px-3 py-2 rounded-md border border-[var(--js-border)] text-sm" data-testid={`contact-${k}`} />
                ))}
                <textarea required placeholder="Message *" value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} data-testid="contact-message" className="w-full px-3 py-2 rounded-md border border-[var(--js-border)] text-sm h-32" />
                <button className="js-btn-primary" data-testid="contact-submit">Send message</button>
              </form>
            }
          </div>
        </div>
      </section>
    </div>
  );
}
